<template>
  <el-container class="body-header" style="height: calc(100vh - 146px);">
    <el-main class="search-person_main">
      <!-- <div class="person_input">
          <el-input v-model="personName" @keyup.enter.native="searchPerson" placeholder="回车进行搜索">
          <el-button type="primary" @click="searchPerson" slot="append">搜索</el-button>
        </el-input>
      </div> -->
      <div class="person_count">共<span>{{ personCount }}</span>条结果</div>
      <div class="person_result">
        <div class="person_Detail" v-for="(item,index) in personList" :key="index">
          





          <div class="WrapperContent" >
              <div >
                <!-- <div v-show="!item.picUrl" ></div> -->
                <div v-show="!item.picUrl" :size="30" class="avatar" :style="{'background-color':getUserColor(item).backgroundColor,'border-radius': '50%','margin-right': '10px','text-align':'center','color':'#fff','font-size':'24px'}"> {{ item.nameCn?item.nameCn.substr(0,1):'' }} </div>
                <img :src="global.BASE_URL + item.picUrl" v-show="item.picUrl" class="avatarImg" style="width:50px; height:50px;">
              </div>
              <div class="UserHeader">
                <h2 style="font-size:16px;">{{ item.nameCn }}</h2>
                <h4 style="padding-top:3px;font-weight:400;" :title="item.deptName">{{item.deptName | omit2}}</h4>
                <p>{{item.orgRelationName}}</p>
              </div>
              <div class="UserMain">
                <h6>手机：{{item.mobile||'无'}}</h6>
                <h6>工号：{{item.userCode||'无'}}</h6>
                <!-- <h6>主职部门：
                  <span>{{ item.deptPath?item.deptPath.replace(',', '/').replace(',', '/') : '无' }}</span>
                </h6> -->
                <div class="badge"  v-show="item.deptManagerFlag === 'Y'">负责人</div>
                <h6>职位：
                  <span>{{ item.positionName || '无' }}</span>
                </h6>
              </div>
              </div>





          <!-- <div style="display: flex; justify-content: center;margin: 20px 0;">
            <div class="person_avatar" :style="{'background-color':returnColor().background}">{{ item.namePy || item.nameCn | filterNamePy }}</div>
          </div>
          <div>{{ item.nameCn }}</div>
          <div class="person_org">{{ item.orgName }}</div> -->
        </div>
        <div class="pserson_more" v-show="personCount > 7" @click="hrefurl">
          <div>查看<br>全部<span v-show="personCount !==0">({{ personCount }})</span></div>
      </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { getUserColor } from '@/assets/common/common.js'
export default {
  name: 'searchPerson',
  data() {
    return {
      getUserColor,
      personName: "",
      personList: [],
      personCount: 0,
    }
  },
  filters: {
    filterNamePy: function(value) {
      if (!value) return;
      if (value.length <= 5) return value;
      let val = value.slice(0, 5)
      return val
    }
  },
  methods: {
    returnColor(){
      let colorList = ['#0cc0c9', '#ffab24', '#2e9cff', '#ff6952']
      let colorList2 = ['rgba(12, 192, 201,.3)', 'rgba(255, 171, 36,.3)', 'rgba(46, 156, 255,.3)', 'rgba(255, 105, 82,.3)']
      const randomIndex = Math.floor(Math.random() * colorList.length)
      console.log(colorList[randomIndex],'colorList[randomIndex]')
      return {background:colorList[randomIndex],shadow:colorList2[randomIndex]}
    },
    searchPerson() {
      console.log('pserson')
      let data = {
        asp: JSON.parse(localStorage.getItem('user')).asp,
        data: {
          categoryCode: "staff",
          nameCn: this.personName
        },
        pageIndex: 0,
        pageSize: 6,
      }
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/base/info/user/findUserBaseInfo', data)
        .then(res => {
          if (res.data.code === '0000') {
            console.log(res.data.data)
            this.personList = res.data.data
            this.personCount = res.data.count
          }
        })
    },
    hrefurl(){
      window.location.href=this.global.BASE_URL_2971+'/#/oaSystem/AddressBook?toDo=0&name='+this.personName;
    }
  },
  created() {
    if (this.$route.params.searchName) {
      this.personName = this.$route.params.searchName
    }
    this.searchPerson()
  },
  mounted() {
    let _this = this
      // 监听刷新消息列表事件
      this.$bus && this.$bus.$on('searchPersonList', (val) => {
        _this.personName = val
        _this.searchPerson();
      });
  },
  beforeDestroy() {
      this.$bus && this.$bus.$off('searchPersonList');
  },
}
</script>

<style lang="less" scoped>
.search-person_main {
  max-width: 1200px;
  margin: 0 auto;
  .person_input {
    max-width: 800px;
    margin: 0 auto;
    height:44px;
    border-radius: 5px;
    .el-input{
      height:44px;
      background-color:#fff;

      /deep/ .el-input__inner {
        height: 44px;}
    }
    .el-button{
      height:44px;
      width:100px;
      background-color:#b40005;
      border-radius:0px 5px 5px 0px;
      color:#fff;
      font-size:16px;
    }
    
  }

  .person_count {
    margin: 20px 0;
    font-size: 16px;

    span {
      color:#bb0009;
      margin: 0 10px;
    }
  }

  .person_result {
    display: flex;
    justify-content: start;
    justify-content: space-evenly;
    flex-wrap: wrap;
    .person_Detail {
      // width: 148px;
      width: 300px;
      height: 200px;
      background-color: #fff;
      margin: 10px 0;
      margin-right: 10px;
      // text-align: center;
      border-radius: 4px;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 10px 0px;

      // .person_avatar {
      //   width: 80px;
      //   height: 80px;
      //   border-radius: 50%;
      //   color: #fff;
      //   display: flex;
      //   justify-content: center;
      //   flex-direction: column;
      // }

      // .person_org {
      //   color: #bebebe;
      //   margin-top: 20px;
      // }
    }

    .person_Detail:nth-child(7){
      margin-right: 0px;
    }

    .pserson_more {
      width: 50px;
      height: 160px;
      background-color: #00bcff;
      color: #fff;
      margin-top: 20px;
      font-size: 16px;
      border-radius: 4px;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 10px 0px;
      cursor: pointer;
      position:absolute;
      top: 245px;
      right: 50px;
      div {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        height: 100%;
      }
    }
  }
}
.WrapperContent {
  // transform:scale(0.8);
  background: #fff;
  border-radius: 5px;
  width: 100%;
  // height: 160px;
  vertical-align: top;
  display: inline-block;
  margin: 0 18px 18px 0;
  // box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 10px 0px;
  margin:0px;
}
.avatar {
  /* display: block; */
  width: 52px;
  height: 52px;
  background-color: #f7f7fc;
  border-radius: 50%;
  position: relative;
  top: 10px;
  left: 10px;
  display:flex;
  justify-content:center;
  align-items: center
}
.avatarImg {
  border-radius: 50%;
  position: relative;
  top: 10px;
  left: 10px;
}
.UserHeader {
  
  display: block;
  position: relative;
  left: 80px;
  top: -40px;
  font-family: PingFangSC-Regular, Microsoft YaHei;
  font-size: 14px;
  color: #565e66;
  letter-spacing: 0;
  line-height: 22px;
  white-space: nowrap;
  height: 0px;
  min-height:25px;
}
.UserMain {
  bottom: 0px;
  font-family: PingFangSC-Regular, Microsoft YaHei;
  font-size: 12px;
  padding-top:0px;
}
.badge {
  margin-left: 80px;
  background-color: #b40005;
  padding: 4px 8px;
  width: fit-content;
  font-size: smaller;
  color: #fff;
  border-radius: 16px;
}
h6, {
  color: #3d3533;
  padding: 5px 20px;
  font-size: 12px;
  font-weight: 400;
  margin:0px;
}
h2,h4{
  margin:0px;
}
a {
  display: inline-block;
  height: 22px;
  font-family: PingFangSC-Regular, Microsoft YaHei;
  font-size: 12px;
  color: #8f9ba6;
  line-height: 22px;
  // text-align: center;
}

</style>


// WEBPACK FOOTER //
// src/views/base/user/search-person.vue